import React, { ReactElement } from 'react';
import { ContentLoadingProps } from 'b2b-apps/shop/common/components';

export const ContentLoading = ({ title, src, srcSet }: ContentLoadingProps): ReactElement => (
  <>
    <h5 className='ModalInProgress-Title'>{title}</h5>

    <div className='ModalInProgress-ModalContent'>
      <img
        alt={title}
        className='ModalInProgress-Image'
        src={src}
        srcSet={`${srcSet} 2x`}
        title={title}
      />

      <div className='ModalInProgress-Dot ModalInProgress-Dot--Dot1' />
      <div className='ModalInProgress-Dot ModalInProgress-Dot--Dot2' />
      <div className='ModalInProgress-Dot ModalInProgress-Dot--Dot3' />
      <div className='ModalInProgress-Dot ModalInProgress-Dot--Dot4' />
      <div className='ModalInProgress-Dot ModalInProgress-Dot--Dot5' />
    </div>
  </>
);
